<template lang="pug">
div(v-if='show', :style='containerStyle')
    i(style='font-size: 80px')
        svg(
            xmlns='http://www.w3.org/2000/svg',
            viewBox='0 0 20 20',
            width='80',
            height='80'
        )
            path(
                fill='#ABAAAA',
                d='M2.93 17.07A10 10 0 1 1 17.07 2.93A10 10 0 0 1 2.93 17.07zM9 5v6h2V5H9zm0 8v2h2v-2H9z'
            )
    span.text-center.texto-cultura-nao-selecionada {{ primaryText }}
    span.text-center.texto-cultura-nao-selecionada-secundario {{ secondaryText }}
</template>

<script>
export default {
    name: 'AvisoCulturaNaoSelecionada',
    props: {
        show: {
            type: Boolean,
            default: true
        },
        tabAtiva: {
            type: String,
            default: '1'
        },
        culturaSelecionada: {
            type: String,
            default: ''
        }
    },
    computed: {
        containerStyle() {
            return {
                height: '330px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            };
        },
        primaryText() {
            return this.$t('mensagens.monitoramentoAgricola.culturaNaoSelecionada');
        },
        secondaryText() {
            return this.$t('mensagens.monitoramentoAgricola.necessarioSelecionarCultura');
        }
    }
};
</script>
<style scoped>
.texto-cultura-nao-selecionada {
    font-family: 'Roboto', 'sans serif' !important;
    color: #3b3b3b;
    font-size: 20px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: center;
    margin-top: 12px;
}
.texto-cultura-nao-selecionada-secundario {
    font-family: 'Roboto', 'sans serif' !important;
    color: #3b3b3b;
    font-size: 17px;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    margin-top: 15px;
}
</style>
